import { valoresSeleccion } from '../valoresSeleccion.model';

export class campos {
idCampo:number;
descCampo:string;
idTipoCampo:number;
descTipoCampos:string
idPlantilla:number;
descPlantilla:string;
idEsquema:number;
idSeccion:number;
descSeccion:string;
orden:number;
longitud:number;
expReg:string;
isRequired:boolean;
idAnt:number;
valoresSeleccion:Array<valoresSeleccion>;
}